(function () {
  'use strict';

  /* ---------- Countdown timer ---------- */
  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', class extends HTMLElement {
      connectedCallback() {
        this.h = this.querySelector('[data-h]');
        this.m = this.querySelector('[data-m]');
        this.s = this.querySelector('[data-s]');
        this.end = this.getEnd();
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      getEnd() {
        const now = Date.now();
        if (this.dataset.mode === 'evergreen') {
          const ms = (parseInt(this.dataset.hours, 10) || 6) * 3600000;
          const key = 'cd-' + (this.dataset.key || 'timer');
          let end = 0;
          try { end = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
          if (!end || end <= now) {
            end = now + ms;
            try { localStorage.setItem(key, String(end)); } catch (e) {}
          }
          return end;
        }
        const d = new Date();
        d.setHours(24, 0, 0, 0);
        return d.getTime();
      }
      tick() {
        let diff = this.end - Date.now();
        if (diff <= 0) { this.end = this.getEnd(); diff = this.end - Date.now(); }
        const t = Math.floor(diff / 1000);
        const pad = (n) => String(n).padStart(2, '0');
        this.h.textContent = pad(Math.floor(t / 3600));
        this.m.textContent = pad(Math.floor((t % 3600) / 60));
        this.s.textContent = pad(t % 60);
      }
    });
  }

  /* ---------- Menu drawer ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const d = document.getElementById(opener.dataset.drawerOpen);
      if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); }
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      const d = e.target.closest('.drawer');
      if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); }
    }
  });

  /* ---------- Generic scroll-snap slider (arrows + dots) ---------- */
  function initSlider(root) {
    if (root.dataset.sliderReady) return;
    root.dataset.sliderReady = '1';
    const track = root.querySelector('[data-slider-track]');
    if (!track) return;
    const slides = Array.from(track.children);
    const dotsWrap = root.querySelector('[data-slider-dots]');
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth);
    const pages = () => Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1);
    let dots = [];
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      const n = Math.min(pages(), slides.length);
      if (n <= 1) { dots = []; return; }
      dots = Array.from({ length: n }, (_, i) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'slider-dot'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', () => track.scrollTo({ left: i * step(), behavior: 'smooth' }));
        dotsWrap.appendChild(b);
        return b;
      });
      update();
    }
    function update() {
      const i = Math.round(track.scrollLeft / step());
      dots.forEach((d, k) => d.classList.toggle('is-active', k === Math.min(i, dots.length - 1)));
    }
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    const prev = root.querySelector('[data-slider-prev]');
    const next = root.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', () => {
      if (track.scrollLeft <= 2) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', () => {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    buildDots();
    window.addEventListener('resize', buildDots);
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    if (root.dataset.tabsReady) return;
    root.dataset.tabsReady = '1';
    const btns = root.querySelectorAll('[data-tab]');
    const panels = root.querySelectorAll('[data-panel]');
    btns.forEach((b) => b.addEventListener('click', () => {
      btns.forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      panels.forEach((p) => { p.hidden = p.dataset.panel !== b.dataset.tab; });
    }));
  }

  /* ---------- Reviews pagination ---------- */
  function initReviews(root) {
    if (root.dataset.reviewsReady) return;
    root.dataset.reviewsReady = '1';
    const items = Array.from(root.querySelectorAll('[data-review]'));
    const per = parseInt(root.dataset.perPage, 10) || 5;
    const pagesWrap = root.querySelector('[data-reviews-pages]');
    const total = Math.ceil(items.length / per);
    if (total <= 1 || !pagesWrap) return;
    let page = 1;
    function render() {
      items.forEach((el, i) => { el.hidden = Math.floor(i / per) + 1 !== page; });
      pagesWrap.innerHTML = '';
      const mk = (label, p, disabled, active) => {
        const b = document.createElement('button');
        b.type = 'button'; b.innerHTML = label; b.disabled = disabled;
        if (active) b.classList.add('is-active');
        b.addEventListener('click', () => { page = p; render(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        pagesWrap.appendChild(b);
      };
      mk('&larr; Prev', page - 1, page === 1, false);
      for (let p = 1; p <= total; p++) mk(String(p), p, false, p === page);
      mk('Next &rarr;', page + 1, page === total, false);
    }
    render();
  }

  /* ---------- Stat count-up ---------- */
  function initCounters() {
    const els = document.querySelectorAll('[data-count]:not([data-count-ready])');
    if (!els.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        const el = en.target;
        const raw = el.dataset.count;
        const m = raw.match(/^([^0-9]*)([0-9][0-9,.]*)(.*)$/);
        if (!m) return;
        const target = parseFloat(m[2].replace(/,/g, ''));
        const decimals = (m[2].split('.')[1] || '').length;
        const commas = m[2].indexOf(',') > -1;
        const start = performance.now();
        const dur = 1400;
        const fmt = (v) => {
          let s = v.toFixed(decimals);
          if (commas) s = Number(s).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
          return m[1] + s + m[3];
        };
        (function frame(t) {
          const p = Math.min(1, (t - start) / dur);
          el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(frame); else el.textContent = raw;
        })(start);
      });
    }, { threshold: 0.4 });
    els.forEach((el) => { el.setAttribute('data-count-ready', ''); io.observe(el); });
  }

  /* ---------- Ship-by date ---------- */
  function initShipDates() {
    document.querySelectorAll('[data-ship-date]').forEach((el) => {
      let days = parseInt(el.dataset.days, 10) || 0;
      const d = new Date();
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) days--;
      }
      const str = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      el.textContent = (el.dataset.template || 'Ships by [date]').replace('[date]', str);
    });
  }

  /* ---------- Product form ---------- */
  function initProduct(section) {
    if (section.dataset.productReady) return;
    section.dataset.productReady = '1';
    const form = section.querySelector('[data-product-form]');
    if (!form) return;
    const idInput = form.querySelector('[data-variant-input]');
    const qtyInput = form.querySelector('[data-qty-input]');
    const planInput = form.querySelector('[data-selling-plan-input]');
    const addBtn = form.querySelector('[data-add-button]');
    const addText = form.querySelector('[data-add-text]');
    const errorEl = form.querySelector('[data-form-error]');
    let product = null;
    try { product = JSON.parse(section.querySelector('[data-product-json]').textContent); } catch (e) {}

    function variantById(id) {
      return product && product.variants.find((v) => String(v.id) === String(id));
    }
    function setAvailability(id) {
      const v = variantById(id);
      if (!addBtn || !v) return;
      addBtn.disabled = !v.available;
      if (addText) {
        if (!addText.dataset.label) addText.dataset.label = addText.textContent;
        addText.textContent = v.available ? addText.dataset.label : 'Sold out';
      }
    }
    function selectTier(tier) {
      section.querySelectorAll('[data-tier]').forEach((t) => {
        const on = t === tier;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      idInput.value = tier.dataset.variantId;
      qtyInput.value = tier.dataset.qty || 1;
      setAvailability(tier.dataset.variantId);
    }
    section.querySelectorAll('[data-tier]').forEach((t) => t.addEventListener('click', () => selectTier(t)));
    const startTier = section.querySelector('[data-tier].is-selected');
    if (startTier) setAvailability(startTier.dataset.variantId);

    const select = section.querySelector('[data-variant-select]');
    if (select) {
      select.addEventListener('change', () => {
        idInput.value = select.value;
        const opt = select.selectedOptions[0];
        const priceEl = section.querySelector('[data-price]');
        const cmpEl = section.querySelector('[data-compare]');
        if (priceEl && opt) priceEl.innerHTML = opt.dataset.price;
        if (cmpEl && opt) { cmpEl.innerHTML = opt.dataset.compare || ''; cmpEl.hidden = !opt.dataset.compare; }
        setAvailability(select.value);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url.toString());
      });
    }

    const qtyVisible = section.querySelector('[data-qty-visible]');
    if (qtyVisible) {
      const sync = () => { const n = Math.max(1, parseInt(qtyVisible.value, 10) || 1); qtyVisible.value = n; qtyInput.value = n; };
      qtyVisible.addEventListener('change', sync);
      section.querySelector('[data-qty-minus]').addEventListener('click', () => { qtyVisible.value = Math.max(1, (parseInt(qtyVisible.value, 10) || 1) - 1); sync(); });
      section.querySelector('[data-qty-plus]').addEventListener('click', () => { qtyVisible.value = (parseInt(qtyVisible.value, 10) || 1) + 1; sync(); });
    }

    const sub = section.querySelector('[data-subscribe]');
    if (sub && planInput) {
      const syncSub = () => { planInput.disabled = !sub.checked; planInput.value = sub.checked ? sub.dataset.planId : ''; };
      sub.addEventListener('change', syncSub);
      syncSub();
    }

    form.addEventListener('submit', () => {
      if (errorEl) errorEl.hidden = true;
      if (addBtn) addBtn.setAttribute('aria-busy', 'true');
    });

    const sticky = section.querySelector('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(([en]) => {
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(addBtn);
    }

    /* Gallery */
    const track = section.querySelector('[data-gallery-track]');
    const thumbs = section.querySelectorAll('[data-thumb]');
    if (track && thumbs.length) {
      thumbs.forEach((th) => th.addEventListener('click', () => {
        const i = parseInt(th.dataset.thumb, 10);
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }));
      track.addEventListener('scroll', () => requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach((th, k) => th.classList.toggle('is-active', k === i));
      }), { passive: true });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-slider]').forEach(initSlider);
    document.querySelectorAll('[data-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initCounters();
    initShipDates();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Re-init inside the theme editor when sections change */
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', (e) => {
    const el = e.target;
    if (el && el.matches && el.matches('[data-tier]')) el.click();
  });
})();
